import styles from "./ReviewsSection.module.css";

import React, { useState, useRef, useEffect } from "react";
import { teamData } from "../../data/teamData.js";


const ReviewsSection = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const trackRef = useRef(null);
  const [cardWidth, setCardWidth] = useState(0);

  const [cardsToShow, setCardsToShow] = useState(4);
  const [cardsToScroll, setCardsToScroll] = useState(1);

  const totalItems = teamData.length;
  const isScrollable = totalItems > cardsToShow;
  const maxScrollIndex = Math.max(0, totalItems - cardsToShow);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth <= 576) {
        setCardsToShow(1);
        setCardsToScroll(1);
      } else if (window.innerWidth <= 1024) {
        setCardsToShow(2);
        setCardsToScroll(2);
      } else {
        setCardsToShow(4);
        setCardsToScroll(1);
      }
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const calculateCardWidth = () => {
      if (trackRef.current && trackRef.current.children[0]) {
        const firstCard = trackRef.current.children[0];
        const gap =
          parseInt(window.getComputedStyle(trackRef.current).gap, 10) || 24;
        setCardWidth(firstCard.offsetWidth + gap);
      }
    };
    calculateCardWidth();
    window.addEventListener("resize", calculateCardWidth);
    return () => window.removeEventListener("resize", calculateCardWidth);
  }, [cardsToShow]);

  useEffect(() => {
    if (currentIndex > maxScrollIndex) {
      setCurrentIndex(maxScrollIndex);
    }
  }, [currentIndex, maxScrollIndex]);

  const handlePrev = () => {
    if (!isScrollable) return;
    const newIndex = currentIndex - cardsToScroll;
    setCurrentIndex(newIndex < 0 ? maxScrollIndex : newIndex);
  };

  const handleNext = () => {
    if (!isScrollable) return;
    const newIndex = currentIndex + cardsToScroll;
    setCurrentIndex(newIndex > maxScrollIndex ? 0 : newIndex);
  };

  return (
    <section className={styles.teamSection}>
      <h1 className={styles.teamSectionTitle}>
        글이 책이 되는 순간, 가장 든든한 동료가 되어드리겠습니다!
      </h1>
      <div className={styles.teamSliderWrapper}>
        <button
          onClick={handlePrev}
          className={`${styles.sliderNav} ${styles.prev}`}
          disabled={!isScrollable}
        >
          <img
            src="./images/gray-arrow-down.png"
            style={{
              transform: "rotate(90deg)",
              filter:
                "brightness(0) saturate(100%) invert(62%) sepia(2%) saturate(2531%) hue-rotate(169deg) brightness(92%) contrast(91%)",
            }}
            alt="Previous"
          />
        </button>
        <div className={styles.sliderContainer}>
          <div
            className={styles.sliderTrack}
            ref={trackRef}
            style={{ transform: `translateX(-${currentIndex * cardWidth}px)` }}
          >
            {teamData.map((member) => (
              <div key={member.id} className={styles.expertCard}>
                <div className={styles.cardTop}>
                  {member.image && (
                    <img
                      src={member.image}
                      alt={member.name}
                      className={styles.profileImage}
                    />
                  )}

                  <div className={styles.cardTopText}>
                    <h2 className={styles.expertName}>{member.name}</h2>
                    <p className={styles.expertTitle}>{member.title}</p>
                    {member.email && (
                      <a
                        // href={`mailto:${member.email}`}
                        href={`mailto:${member.email}?subject=${encodeURIComponent("[acornon.kr] 출판 문의 ")}`}
                        target="_blank" rel="noreferrer"
                        className={styles.expertEmail}
                      >
                        {member.email}
                      </a>
                    )}
                    {/* {member.email && (
                      <div className={styles.expertEmail}>
                        {member.email}
                      </div>
                    )} */}
                  </div>
                </div>                
                <div className={styles.cardBottom}>
                  <div className={styles.infoBlock}>
                    <div className={styles.skillTags}>
                      {member.tags.map((tag) => (
                        <span key={tag} className={styles.tag}>
                          {tag}
                        </span>
                      ))}
                    </div>
                  </div>
                  <div className={styles.infoBlock}>
                    <ul>
                      {member.achievements.map((item) => (
                        <li key={item}>{item}</li>
                      ))}
                    </ul>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
        <button
          onClick={handleNext}
          className={`${styles.sliderNav} ${styles.next}`}
          disabled={!isScrollable}
        >
          <img
            src="./images/gray-arrow-down.png"
            style={{
              transform: "rotate(270deg)",
              filter:
                "brightness(0) saturate(100%) invert(62%) sepia(2%) saturate(2531%) hue-rotate(169deg) brightness(92%) contrast(91%)",
            }}
            alt="Next"
          />
        </button>
      </div>
    </section>
  );
};
export default ReviewsSection;
